import React from "react";
import i18n from "../../i18n/i18n";
import {Button, CircularProgress} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import AssignmentIcon from "@mui/icons-material/Assignment";
import * as PropTypes from "prop-types";
import { withStyles } from 'tss-react/mui';
import {withTranslation} from "react-i18next";

const styles = theme => ({
    root: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
    },
    button: {
        margin: "0 10px",
        "&:first-child": {
            marginLeft: 0
        },
        "&:last-child": {
            marginRight: 0
        }
    },
    loadingIcon: {
        width: "32px",
        height: "32px"
    },
    rightIcon: {
        marginLeft: theme.spacing(2),
    },
    progressPrimary: {
        color: theme.palette.primary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    progressSecondary: {
        color: theme.palette.secondary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
});

AssignmentIcon.propTypes = {className: PropTypes.shape({marginLeft: PropTypes.func})};

SaveIcon.propTypes = {className: PropTypes.shape({marginLeft: PropTypes.func})};

class AssignmentButtons extends React.Component {

    constructor(props) {
        super(props);

        this.onClickTest = this.onClickTest.bind(this);
        this.onClickSend = this.onClickSend.bind(this);
    }

    render() {
        const {classes, solutionIsBeingValidated, solutionIsBeingSent, disabled} = this.props;

        const shouldBeDisabled = disabled || solutionIsBeingValidated || solutionIsBeingSent;

        return (
            <div className={classes.root}>
                <Button disabled={shouldBeDisabled} onClick={this.onClickTest}
                        color="primary" variant="contained"
                        className={classes.button}>
                    {i18n.t("codeAssignmentPage:validateSolution")}
                    <AssignmentIcon className={classes.rightIcon}/>
                    {solutionIsBeingValidated && <CircularProgress size={24} className={classes.progressPrimary}/>}
                </Button>

                <Button disabled={shouldBeDisabled} onClick={this.onClickSend}
                        color="secondary" variant="contained"
                        className={classes.button}>
                    {i18n.t("codeAssignmentPage:sendSolution")}
                    <SaveIcon className={classes.rightIcon}/>
                    {solutionIsBeingSent && <CircularProgress size={24} className={classes.progressSecondary}/>}
                </Button>
            </div>
        );
    }

    onClickTest(e) {
        e.preventDefault();
        this.props.onAssignmentTest();
    }

    onClickSend(e) {
        e.preventDefault();
        this.props.onAssignmentSend();
    }
}

const assignmentButtonsWithStyles = withStyles(AssignmentButtons, styles)

export default withTranslation()(assignmentButtonsWithStyles);
